import { render, staticRenderFns } from "./ServiceProductsModalForm.vue?vue&type=template&id=70384b55"
import script from "./ServiceProductsModalForm.vue?vue&type=script&lang=ts"
export * from "./ServiceProductsModalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports